import { useEffect, useMemo } from 'react';
import { useLocation } from 'react-router';

function useClearSession() {
  const location = useLocation();

  // Flujo de navegacion para borrar la session
  const flow = useMemo(() => [
    '/',
    '/Hotels',
    '/Checking',
  ], []);

  useEffect(() => {
    if (flow.includes(location.pathname)) {
      localStorage.removeItem('session');
    }
  }, [location.pathname, flow]);
}

export default useClearSession;
